// extracted by mini-css-extract-plugin
export default {"tasksContainer":"task-list_tasksContainer__I3b4c"};